import { graphql } from '@/generated/gql';

export const SUPPLIER_CONTACT_NAME_POLICY_QUERY = graphql(/* GraphQL */ `
  query SupplierContactNamePolicyQuery {
    tesseract {
      supplierContactSettings {
        namePolicy
      }
    }
  }
`);
